export default __webpack_public_path__ + "static/media/home_white_24dp.4943a2ee.svg";